import React from "react";

export const LeaseIcon = ({
  fill = "",
  width = "20",
  height = "20",
  className = "",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={width}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 14.7904H12.5C12.6774 14.7904 12.8258 14.7305 12.9454 14.6108C13.0651 14.4912 13.125 14.3427 13.125 14.1654C13.125 13.988 13.0651 13.8395 12.9454 13.7199C12.8258 13.6002 12.6774 13.5404 12.5 13.5404H7.5C7.32264 13.5404 7.17417 13.6002 7.05458 13.7199C6.93486 13.8395 6.875 13.988 6.875 14.1654C6.875 14.3427 6.93486 14.4912 7.05458 14.6108C7.17417 14.7305 7.32264 14.7904 7.5 14.7904ZM7.5 11.457H12.5C12.6774 11.457 12.8258 11.3972 12.9454 11.2774C13.0651 11.1579 13.125 11.0094 13.125 10.832C13.125 10.6547 13.0651 10.5062 12.9454 10.3866C12.8258 10.2669 12.6774 10.207 12.5 10.207H7.5C7.32264 10.207 7.17417 10.2669 7.05458 10.3866C6.93486 10.5062 6.875 10.6547 6.875 10.832C6.875 11.0094 6.93486 11.1579 7.05458 11.2774C7.17417 11.3972 7.32264 11.457 7.5 11.457ZM5.25646 17.9154C4.83549 17.9154 4.47917 17.7695 4.1875 17.4779C3.89583 17.1862 3.75 16.8299 3.75 16.4089V3.58849C3.75 3.16752 3.89583 2.8112 4.1875 2.51953C4.47917 2.22786 4.83549 2.08203 5.25646 2.08203H11.2517C11.4525 2.08203 11.6456 2.12106 11.831 2.19911C12.0163 2.27703 12.1774 2.38439 12.3142 2.5212L15.8108 6.01786C15.9476 6.15467 16.055 6.31571 16.1329 6.50099C16.211 6.68641 16.25 6.87953 16.25 7.08036V16.4089C16.25 16.8299 16.1042 17.1862 15.8125 17.4779C15.5208 17.7695 15.1645 17.9154 14.7435 17.9154H5.25646ZM11.25 6.3287V3.33203H5.25646C5.19229 3.33203 5.13354 3.35877 5.08021 3.41224C5.02674 3.46557 5 3.52432 5 3.58849V16.4089C5 16.4731 5.02674 16.5318 5.08021 16.5852C5.13354 16.6386 5.19229 16.6654 5.25646 16.6654H14.7435C14.8077 16.6654 14.8665 16.6386 14.9198 16.5852C14.9733 16.5318 15 16.4731 15 16.4089V7.08203H12.0033C11.7885 7.08203 11.6092 7.01016 11.4656 6.86641C11.3219 6.7228 11.25 6.54356 11.25 6.3287Z"
        fill={fill}
      />
    </svg>
  );
};

export default LeaseIcon;
